import { currentClientSelector, isAdvisorSelector } from "../user/selectors";
import { async_func_data, handleResponse } from "./../Utils/helperfunctions";
import { GENERAL_EMPLOYER, GENERAL_EMPLOYER_NEW, GENERAL_FUTURE_EXPENSES_TABLE, RESET_GENERAL, } from "./types";
import { SUCCESS_CODE } from "../../constants";
import { removeCommaString } from "../../functions";
import { sendAlert } from "../global/actions";
export const get_employer_list = (value) => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("employee/getemployee", { ent_key: value }, [getState, dispatch], "get", false);
    const { employees } = responseData;
    handleResponse(errorCode, dispatch);
    return employees.slice(0, 10);
};
// Remove later
export const get_employer_list_beg = (value) => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("employee/getemployee", { ent_key: value }, [getState, dispatch], "get");
    const { employees } = responseData;
    handleResponse(errorCode, dispatch, generalEmployer({
        employer_list: employees?.splice(0, 10),
        search_loading: false,
    }));
};
export const fetch_allocations = (ent_params, newEmp = false) => async (dispatch, getState) => {
    const isToken = getState().userReducer.token;
    const { responseData, errorCode } = await async_func_data(isToken ? "employee/getallocation" : "employee/getallocationunauth", { ein: String(ent_params.ein) }, [getState, dispatch], "get", isToken ? true : false);
    const { allocations } = responseData;
    handleResponse(ent_params.showLimitExceedError ? errorCode : null, dispatch, !newEmp
        ? generalEmployer({
            funds: allocations || [],
            employer_list: [],
            value: ent_params.name,
            showFunds: true,
            funds_load: false,
            employer_selected: true,
        })
        : generalEmployerNew({
            employer_selected: ent_params.name,
            funds: allocations || [],
            selected_ein: +ent_params.ein,
        }));
};
export const get_fees_saved = () => async (dispatch, getState) => {
    const { responseData, errorCode } = await async_func_data("employee/getfeessaved", { ein: `${getState().generalReducer.employerNew.selected_ein}` }, [getState, dispatch], "get");
    const { fees } = responseData;
    handleResponse(errorCode, dispatch);
    return fees?.length ? fees[0] : [];
};
export const get_future_expense_planner = (retireDate) => async (dispatch, getState) => {
    const isAdvisor = isAdvisorSelector(getState());
    const isToken = getState().userReducer.token;
    const userId = isAdvisor
        ? currentClientSelector(getState())?.uuid
        : getState().userReducer.userData?.uuid;
    const dob = isAdvisor
        ? currentClientSelector(getState())?.dob || "1993-01-01"
        : getState().userReducer.userData?.dob || "1993-01-01";
    const { responseData, errorCode } = await async_func_data("transaction/getFutureExpenses", { retireDate: `${retireDate}-01-01`, userId, dob: dob || "1993-01-01" }, [getState, dispatch], "get", isToken ? true : false);
    const { futureExpenses, socialSecurity } = responseData;
    handleResponse(errorCode, dispatch, null);
    return { futureExpenses, socialSecurity };
};
export const saveFutureExpenses = (listData) => async (dispatch, getState) => {
    const userId = getState().userReducer.userData?.uuid;
    const sendResonse = [];
    listData.map((item) => {
        if (item.new_future) {
            sendResonse.push({
                userId,
                category: item.category,
                futureExpense: removeCommaString(item.new_future),
            });
        }
    });
    const { errorCode } = await async_func_data("transaction/editFutureExpenses", { data: sendResonse }, [getState, dispatch], "post");
    handleResponse(errorCode, dispatch, null);
    if (errorCode !== SUCCESS_CODE) {
        dispatch(sendAlert({
            title: "Error",
            textContent: "Retirement expenses update failed.",
        }));
        return errorCode;
    }
    else {
        return SUCCESS_CODE;
    }
};
export const resetFutureExpenses = (category) => async (dispatch, getState) => {
    const userId = getState().userReducer.userData?.uuid;
    const { errorCode } = await async_func_data("transaction/deleteFutureExpenses", { userId, category }, [getState, dispatch], "delete");
    handleResponse(errorCode, dispatch, null);
    if (errorCode !== SUCCESS_CODE) {
        dispatch(sendAlert({ title: "Error", textContent: "Reset Expenses failed." }));
        return errorCode;
    }
    else {
        return SUCCESS_CODE;
    }
};
export const generalEmployer = (payload) => ({
    type: GENERAL_EMPLOYER,
    payload,
});
export const generalEmployerNew = (payload) => ({
    payload,
    type: GENERAL_EMPLOYER_NEW,
});
export const generalFutureExpTable = (payload) => ({
    type: GENERAL_FUTURE_EXPENSES_TABLE,
    payload,
});
export const resetGeneralStore = () => ({
    type: RESET_GENERAL,
});
